import { FieldValues } from "react-hook-form";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import { AavoForm } from "src/components/common/forms/AavoForm.tsx";
import type { ShowFormInputDialogParams } from "src/components/common/dialogs/formInput/useFormInput.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface FormInputContentProps<TFieldValues extends FieldValues>
	extends ShowFormInputDialogParams<TFieldValues>, FormCommonProps<TFieldValues> {}

export const FormInputContent = <TFieldValues extends FieldValues>({
	onCompleted,
	defaultValues,
	content: contentCreator,
	submitLabel,
	onSubmit,
	onFormEdited,
	disabled,
	submitOnEnter,
	agentContext,
}: FormInputContentProps<TFieldValues>) => {
	return (
		<AavoForm<TFieldValues, TFieldValues>
			submit={async (values) => {
				if (onSubmit) {
					await onSubmit(values);
				}
				return values;
			}}
			columns={1}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			defaultValues={defaultValues}
			submitLabel={submitLabel}
			fitContent
			useFormProps={{ disabled }}
			submitOnEnter={submitOnEnter}
			agentContext={{
				key: defineAgentUiContextKey("common.formInputDialog.form"),
				data: agentContext?.data,
			}}
			render={(useFormReturn) => contentCreator(useFormReturn)}
		/>
	);
};
